import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'

import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'

import Select from 'react-select'

import NavbarSA from '../../../components/navbar-sa'
import server from '../../../variables'

const EditSchemeUser = () => {
  const notyf = new Notyf()
  const navigate = useNavigate()
  const { id: schemeID, user: userID } = useParams()

  const [user, setUser] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const roleList = [
    { label: 'Manager', value: 'manager' },
    { label: 'Field', value: 'field' },
    { label: 'Monitoring', value: 'monitoring' },
  ]

  /* ---------------- handlers ---------------- */

  const handleInpChange = (e) => {
    const { name, value } = e.target
    setUser((prev) => ({ ...prev, [name]: value }))
  }

  const handleRoleChange = (option) => {
    setUser((prev) => ({ ...prev, role: option.value }))
  }

  /* ---------------- API calls ---------------- */

  const getUser = async () => {
    try {
      const { data } = await Axios.get(
        server + 'admin/get-user/' + userID,
        { headers: { authorization: localStorage.getItem('token') } }
      )

      if (data.status === 200) {
        setUser(data.user)
      } else if (data.status === 410) {
        navigate('/')
      } else {
        notyf.error(data.message)
      }
    } catch (err) {
      console.error(err)
      notyf.error('Internal Server Error')
    }
  }

  const editUser = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      const { data } = await Axios.post(
        server + 'admin/update-user/' + userID,
        user,
        { headers: { authorization: localStorage.getItem('token') } }
      )

      if (data.status === 200) {
        notyf.success('User updated successfully')
        navigate(`/admin/scheme/${schemeID}`)
      } else if (data.status === 410) {
        navigate('/')
      } else {
        notyf.error(data.message)
      }
    } catch (err) {
      console.error(err)
      notyf.error('Internal Server Error')
    } finally {
      setIsLoading(false)
    }
  }

  const deleteUser = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      const { data } = await Axios.post(
        server + 'admin/delete-user',
        { id: user._id },
        { headers: { authorization: localStorage.getItem('token') } }
      )

      if (data.status === 200) {
        notyf.success('User deleted successfully')
        navigate(`/admin/scheme/${schemeID}`)
      } else if (data.status === 410) {
        navigate('/')
      } else {
        notyf.error(data.message)
      }
    } catch (err) {
      console.error(err)
      notyf.error('Internal Server Error')
    } finally {
      setIsLoading(false)
    }
  }

  /* ---------------- lifecycle ---------------- */

  useEffect(() => {
    document.title = 'Rean Billing System'
    getUser()
  }, [])

  /* ---------------- UI ---------------- */

  return (
    <div className="page-wrapper">
      <NavbarSA />

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">

            <Card className="shadow-sm rounded-4">
              <CardHeader
                title={user.name || 'Edit User'}
                subheader={`User ID: ${user.userID || '-'}`}
              />

              <CardContent>
                <form>

                  <TextField
                    label="User Name"
                    name="name"
                    value={user.name || ''}
                    onChange={handleInpChange}
                    fullWidth
                    size="small"
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    label="Email"
                    name="email"
                    value={user.email || ''}
                    onChange={handleInpChange}
                    fullWidth
                    size="small"
                    sx={{ mb: 2 }}
                  />

                  <div style={{ marginBottom: 16 }}>
                    <Select
                      placeholder="Select Role"
                      options={roleList}
                      value={roleList.find(
                        (r) => r.value === user.role
                      )}
                      onChange={handleRoleChange}
                    />
                  </div>

                  <TextField
                    label="Remarks"
                    name="remarks"
                    value={user.remarks || ''}
                    onChange={handleInpChange}
                    fullWidth
                    multiline
                    rows={3}
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    label="New Password"
                    name="password"
                    type="password"
                    onChange={handleInpChange}
                    fullWidth
                    size="small"
                    sx={{ mb: 3 }}
                  />

                  <div className="d-flex gap-2">
                    <Button
                      variant="contained"
                      fullWidth
                      disabled={isLoading}
                      onClick={editUser}
                    >
                      Save User
                    </Button>

                    <Button
                      variant="outlined"
                      color="error"
                      fullWidth
                      disabled={isLoading}
                      onClick={deleteUser}
                    >
                      Delete User
                    </Button>
                  </div>

                </form>
              </CardContent>
            </Card>

          </div>
        </div>
      </div>
    </div>
  )
}

export default EditSchemeUser
